export const TAGGIN_INFO = {
  componentName: "Footer",
  componentContent: "",
  componentVariation: "all",
  componentProduct: "",
};

